import { render, staticRenderFns } from "./BottomDefault.vue?vue&type=template&id=48daedda&scoped=true"
import script from "./BottomDefault.vue?vue&type=script&lang=js"
export * from "./BottomDefault.vue?vue&type=script&lang=js"
import style0 from "./BottomDefault.vue?vue&type=style&index=0&id=48daedda&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48daedda",
  null
  
)

export default component.exports